import React, { useEffect, useMemo } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AuthLayout, AuthLayoutActions, AuthLayoutClearFix } from '../../layouts/Auth'
import { QuickLoginButtons } from './components/QuickLoginButtons'

import './styles.css'

export const Confirm: React.FC = () => {
  const loc = useLocation()

  const emailUsed = useMemo(() => loc.state?.emailUsed ?? '', [])

  useEffect(() => {
    setTimeout(() => {
      toast.success('We sent you a link to login')
    }, 2000)
  }, [])

  return (
    <AuthLayout>
      <h1>
        We sent <span>{emailUsed || 'you' }</span> a link to login
        <br />
      </h1>
      <h3>You can close this page.</h3>
      <br />

      <QuickLoginButtons />

      <AuthLayoutActions>
        <AuthLayoutClearFix />
        <Link to="/login">
          <button type="button" className="secondary">
            Go back
          </button>
        </Link>
        <AuthLayoutClearFix />
      </AuthLayoutActions>
      <div className="login-notes">
        <p>Make sure to check your spam folder!</p>
        <p>Login link expires in 1 hour</p>
      </div>
    </AuthLayout>
  )
}
